export default function createWorker(context: Function): Worker {
  let code = context?.toString();
  code = code?.substring(code?.indexOf('{') + 1, code?.lastIndexOf('}'));

  const blob = new Blob([code], { type: 'application/javascript' });
  const url = URL.createObjectURL(blob);
  return new Worker(url);
}
